var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTidal = function SvgIconTidal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.3 19.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.9 4.9 0l4.9 5-5 4.9zm9.8 0L14.7 0l4.9 5-5 4.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.8 14.6 4.9-4.9 4.8 5-4.8 4.8zM19.5 5l4.9-5 4.9 5-4.9 4.8z"
  })));
};
export default SvgIconTidal;